import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import moment from "moment/moment";

export const extensionDisplayStatus = {
    Success: "Successful",
    NA: "NA",
    Failure: "Failed",
}

function baseFailureContent() {
    return {
        title: "Action Required to Extend Rental",
        body: "Your rental was not successfully extended. Please contact Hertz Driver Support at 877-654-6600 for further assistance.",
        statusText: extensionDisplayStatus.Failure,
        bgColor: '#FDECEA',
        icon: <ErrorOutlineIcon/>,
    }
}

const raClosedContent = {
    title: "Rental Closed",
    body: "No action needed. Thanks for choosing Hertz.",
    statusText: extensionDisplayStatus.NA,
    bgColor: '#EAF4FC',
    icon: <ErrorOutlineIcon/>
};
const firstWeekContent = {
    title: "Have a Great First Week!",
    body: "Thanks for choosing Hertz.",
    statusText: extensionDisplayStatus.NA,
    bgColor: '#EFF7EE',
    icon: <CheckCircleOutlineIcon/>
}

function successfulExtensionContent() {
    return {
        title: "In Good Standing",
        body: "Your rental is successfully extended. No action needed. Thank you for choosing Hertz for your rideshare drives.",
        statusText: extensionDisplayStatus.Success,
        bgColor: '#EFF7EE',
        icon: <CheckCircleOutlineIcon/>
    }
}

function getFailureContent(lastAutoExtension) {
    let failureContent = baseFailureContent();
    switch (lastAutoExtension.status) {
        case "FAILED_DUE_TO_PAYMENT_FUND":
        case "FAILED_DUE_TO_PAYMENT_FRAUD":
            failureContent.body = "Your rental was not extended due to a failed authorization. Add funds to your account or contact bank to resolve. Then call 877-654-6600.";
            break;
        case "FAILED_DUE_TO_HOLDS_ON_VEHICLE":
            failureContent.body = "Your rental was not extended due to a maintenance hold on your car. Log in to the Maintenance Portal to resolve. Then call 877-654-6600.";
            break;
        case "FAILED_DUE_TO_TRIP_COUNT_NOT_REACHED":
            failureContent.body = "Your rental was not extended due to not completing the 30-trip weekly minimum. Please return your car. Questions? Email HertzEV3@hertz.com.";
            break;
        case "FAILED_DUE_TO_MAX_EXTENSION_REACHED":
            failureContent.body = "Your rental was not extended as you are past the maximum rental duration. Please bring in your rental to renew your Rental Agreement.";
            break;
        default:
            failureContent.body = "Your rental was not successfully extended. Please contact Hertz Driver Support at 877-654-6600 for further assistance."
    }
    return failureContent;
}

export function isClosed(rentalEvent) {
    return rentalEvent !== null && rentalEvent !== undefined && rentalEvent.raStatus !== "O";
}

export function getExtensionStatusMessage(lastAutoExtension, rentalEvent) {
    if (isClosed(rentalEvent)) return raClosedContent;
    if (lastAutoExtension === null) return firstWeekContent;
    if (lastAutoExtension.status === "SUCCEEDED") return successfulExtensionContent();
    if (wasExtendedManually(lastAutoExtension, rentalEvent)) {
        let extendedManuallyContent = successfulExtensionContent();
        extendedManuallyContent.statusText = extensionDisplayStatus.Failure
        return extendedManuallyContent
    }
    return getFailureContent(lastAutoExtension);
}

export function getMostRecentExtension(autoExtensions) {
    if (autoExtensions === null || autoExtensions === undefined || autoExtensions.length === 0)
        return null;
    let mostRecentExtension = autoExtensions[0];
    let mostRecentDate = new Date(mostRecentExtension.insertedAt);

    for (let i = 1; i < autoExtensions.length; i++) {
        const currentDate = new Date(autoExtensions[i].insertedAt);
        if (currentDate > mostRecentDate) {
            mostRecentExtension = autoExtensions[i];
            mostRecentDate = currentDate;
        }
    }

    return mostRecentExtension;
}

export function wasExtendedManually(lastExtension, rentalEvent) {
    if (lastExtension === null) return false;
    if (rentalEvent === null || rentalEvent === undefined) return false;
    let dueDate = moment.utc(rentalEvent.dueDate);
    let lastExtensionDate = moment.utc(lastExtension.insertedAt)
    return dueDate.isAfter(lastExtensionDate);
}